'use strict';

export class Lsotext {
	constructor(component_key) {
		this.id = component_key;
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		const self = this;
		const $read_more = this.$root.find(`.js-${this.id}_read_more`);
		const $text = this.$root.find(`.js-${this.id}_text`);

		$read_more.on('click', function() {
			const $button = jQuery(this);
			const $label = $button.find(`.js-${self.id}_read_more_label`);
			const collapsed = $text.hasClass('lso--collapsed');

			if (collapsed) {
				$text.removeClass('lso--collapsed');
				$label.text($button.data('label-showless'));
			} else {
				$text.addClass('lso--collapsed');
				$label.text($button.data('label-showmore'));
			}
		});

		$read_more.each(function() {
			if (!$text.length) {
				return;
			}

			if ($text[0].scrollHeight > $text.innerHeight() + 2) {
				jQuery(this).show();
			} else {
				jQuery(this).hide();
			}
		});
	}
}

jQuery(function() {
	Object.keys(yalwa.v.components).forEach(key => {
		if (key.startsWith('lsotext_')) {
			const instance = new Lsotext(key);
			yalwa.v.component_instances[key] = instance;
			instance.init();
		}
	});
});
